import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type ModerationResolveMutationVariables = Types.Exact<{
  surface: Types.ModerationSurface
  itemId: Types.Scalars['ID']['input']
  action: Types.ModerationResolveAction
}>

export type ModerationResolveMutation = {
  __typename?: 'Mutation'
  moderationResolve?: {
    __typename?: 'Comment'
    id?: string | null
    status?: Types.CommentStatus | null
  } | null
}

export const ModerationResolveDocument = gql`
  mutation ModerationResolve(
    $surface: ModerationSurface!
    $itemId: ID!
    $action: ModerationResolveAction!
  ) {
    moderationResolve(surface: $surface, itemId: $itemId, action: $action) {
      id
      status
    }
  }
`
export type ModerationResolveMutationFn = Apollo.MutationFunction<
  ModerationResolveMutation,
  ModerationResolveMutationVariables
>

/**
 * __useModerationResolveMutation__
 *
 * To run a mutation, you first call `useModerationResolveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModerationResolveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moderationResolveMutation, { data, loading, error }] = useModerationResolveMutation({
 *   variables: {
 *      surface: // value for 'surface'
 *      itemId: // value for 'itemId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useModerationResolveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ModerationResolveMutation,
    ModerationResolveMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ModerationResolveMutation, ModerationResolveMutationVariables>(
    ModerationResolveDocument,
    options,
  )
}
export type ModerationResolveMutationHookResult = ReturnType<typeof useModerationResolveMutation>
export type ModerationResolveMutationResult = Apollo.MutationResult<ModerationResolveMutation>
export type ModerationResolveMutationOptions = Apollo.BaseMutationOptions<
  ModerationResolveMutation,
  ModerationResolveMutationVariables
>
